import styled from 'styled-components/macro';

export const HighLevelNumber = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex: 1;
	align-items: center;
`;

export const HighLevelBudgetNumbersStyle = styled.div`
	margin-left: 16px;
	width: 333px;
	height: 350px;
	border: 1px solid #e6e6ed;
	border-radius: 4px;
	background-color: #f7f7fe;

	display: flex;
	flex-direction: column;

	${HighLevelNumber} {
		border-bottom: 1px solid #e6e6ed;
	}

	${HighLevelNumber}:last-child {
		border-bottom: 0;
	}
`;

export const Label = styled.div`
	padding-left: 25px;
	font-size: 13px;
	font-weight: 400;
`;

export const Value = styled.div`
	padding-right: 25px;
	font-size: 13px;
	font-weight: 400;
`;
